import { axiosSwagger } from "@/axios";
import VueJwtDecode from 'vue-jwt-decode';


export const state = {
  user: {
    data: localStorage.getItem("USER") ? JSON.parse(localStorage.getItem("USER")) : '',
    token: localStorage.getItem("TOKEN"),
    accessList: localStorage.getItem("ACCESSLIST"),
  }
}


export const getters = {
  user: () => state.user.data || null,
}


export const mutations = {
  // AUTHENTICATION
  SET_USER: (state, { token, campus, office, deliveryUnit, deliveryUnitIds }) => {
    const userData = VueJwtDecode.decode(token);

    const {
      FirstName: firstName,
      LastName: lastName,
      MiddleName: middleName,
      Email: email,
      IsEmailConfirmed: emailConfirm,
      Position: position,
      "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier": userId,
      "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name": userName,
    } = userData;

    office.campus = campus;
    deliveryUnit.office = office;

    state.user.data = {
      firstName,
      lastName,
      middleName,
      email,
      userId,
      userName,
      emailConfirm,
      position,
      deliveryUnit: deliveryUnit,
      deliveryUnitIds,
    };
    userData?.deliveryUnit?.office?.campus?.id

    localStorage.setItem("USER", JSON.stringify(state.user.data));
  },
  SET_TOKEN: (state, token) => {
    state.user.token = token;
    localStorage.setItem("TOKEN", token);
  },
  SET_ACCESSLIST: (state, data) => {
    state.user.accessList = data;
    localStorage.setItem("ACCESSLIST", data);
  },
  LOGOUT_USER: (state) => {
    localStorage.setItem("USER", '');
    localStorage.setItem("TOKEN", '');
    localStorage.removeItem("SEARCH_HISTORY");

    state.user.token = null;
    state.user.data = null;

    sessionStorage.setItem("reloading", true);
    window.location.reload(true);
  },
}


export const actions = {
  // eslint-disable-next-line no-unused-vars
  async register({ commit }, userData) { // for admin
    return await axiosSwagger
      .post("/api/Account/Create", userData)
      .then((response) => {
        return response;
      });
  },
  // eslint-disable-next-line no-unused-vars
  async signUp({ commit }, userData) { // for users
    return await axiosSwagger
      .post("/api/Account/SignUp", userData)
      .then((response) => {
        return response;
      });
  },
  async login({ commit }, userData) {
    return await axiosSwagger
      .post("/api/Account/login", userData)
      .then( async (response) => {
        if (!response.data.error && response.data.error === undefined) {
          commit("SET_TOKEN", response.data.token);
          commit("SET_ACCESSLIST", response.data.accessList);


          const userData = VueJwtDecode.decode(response.data.token);

          if(userData?.DeliveryUnitIds){
            const DUIds = userData.DeliveryUnitIds.split(",").map(num => parseInt(num.trim(), 10));
            const _deliveryUnitId = DUIds[DUIds?.length-1];
            
            const deliveryUnitData = await readDeliveryUnitById(_deliveryUnitId);
            const officeData = await readOfficeById(deliveryUnitData.officeId);
            const campusData = await readCampusById(officeData.campusId);

            commit("SET_USER", { token: response.data.token, campus: campusData, office: officeData, deliveryUnit: deliveryUnitData, deliveryUnitIds: DUIds });
          }

        }

        return response;
      });
  },
  async loginWithHRIS({ commit }, userData) {
    return await axiosSwagger
      .post("/api/Account/Login/Hris", userData)
      .then((response) => {
        if (!response.data.error && response.data.error === undefined) {
          commit("SET_USER", response.data.token);
          commit("SET_TOKEN", response.data.token);
          commit("SET_ACCESSLIST", response.data.accessList);
        }

        return response;
      });
  },
  async googleSignIn({ commit }, userData) {
    return await axiosSwagger
      .post("/api/Account/Login/Google", userData)
      .then( async (response) => {
        if (!response.data.error && response.data.error === undefined) {
          commit("SET_TOKEN", response.data.token);
          commit("SET_ACCESSLIST", response.data.accessList);


          const userData = VueJwtDecode.decode(response.data.token);

          if(userData?.DeliveryUnitIds){
            const DUIds = userData.DeliveryUnitIds.split(",").map(num => parseInt(num.trim(), 10));
            const _deliveryUnitId = DUIds[DUIds?.length-1];
            
            const deliveryUnitData = await readDeliveryUnitById(_deliveryUnitId);
            const officeData = await readOfficeById(deliveryUnitData.officeId);
            const campusData = await readCampusById(officeData.campusId);

            commit("SET_USER", { token: response.data.token, campus: campusData, office: officeData, deliveryUnit: deliveryUnitData, deliveryUnitIds: DUIds });
          }

        }

        return response;
      });
  },
  async logout({ commit }) {
    // return await axiosClient.post('/logout')
    //   .then(() => {
    //     commit('LOGOUT_USER');
    //   });
    commit("LOGOUT_USER");
  },
  // eslint-disable-next-line no-unused-vars
  async sendEmailVerification({ commit }, userEmail) {
    return await axiosSwagger
      .post(`/api/Account/Email/Send/Confirmation?email=${userEmail}`)
      .then((response) => {
        return response;
      });
  },
  // eslint-disable-next-line no-unused-vars
  async emailVerification({ commit }, requestData) {
    return await axiosSwagger
      .post(`/api/Account/Email/Verify?email=${requestData.email}&code=${requestData.code}`)
      .then((response) => {
        return response;
      });
  },
  // eslint-disable-next-line no-unused-vars
  async forgotPassword({ commit }, data) {
    return await axiosSwagger
      .post("/api/Account/ForgotPassword", data)
      .then((response) => {
        return response;
      });
  },
  // eslint-disable-next-line no-unused-vars
  async resetPassword({ commit }, data) {
    return await axiosSwagger
      .post("/api/Account/ForgotPassword/Verify", data)
      .then((response) => {
        return response;
      });
  },
}



window.onload = function() {
  var reloading = sessionStorage.getItem("reloading");
  if (reloading) {
      sessionStorage.removeItem("reloading");
      resetVuexData();
  }
}

// only reset data. vuex will always persist
function resetVuexData(){
  window.localStorage.removeItem('vuex');
}

async function readDeliveryUnitById (deliveryUnitId) {
  return await axiosSwagger
  .get(`/api/DeliveryUnit/${deliveryUnitId}`)
  .then(async (response) => {
      return response.data;
  });
}

async function readOfficeById(officeId) {
  return await axiosSwagger
  .get(`/api/Office/${officeId}`)
  .then((response) => {

    return response.data;
  });
}

async function readCampusById(campusId) {
  return await axiosSwagger
  .get(`/api/Campus/${campusId}`)
  .then((response) => {

    return response.data;
  });
}